@if (visible) {
  <div class="sm:relative z-1000">
    <div class="fixed inset-0 z-50 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full"></div>
    <div class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex min-h-svh items-center sm:justify-center p-4 text-center sm:p-0">
        <div class="relative transform rounded-md bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6" clickOutside (onClickOutside)="closeModal()">
          <div class="-top-14 -right-2 p-2 flex items-end justify-end w-24 h-24 z-10 absolute" (click)="closeModal()">
            <div class="text-white flex items-center justify-center rounded-full">
              <svg class="h-8 w-8 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>
          <div class="flex flex-col">
            @if (headerText) {
              <header>
                <span class="font-bold">{{ headerText }}</span>
                <div class="my-4">
                  <vti-separator></vti-separator>
                </div>
              </header>
            }
            <main class="mt-4">
              <ng-container *ngTemplateOutlet="content"></ng-container>
            </main>
            @if (footer) {
              <footer>
                <div class="my-4">
                  <vti-separator></vti-separator>
                </div>
                <ng-container *ngTemplateOutlet="footer"></ng-container>
              </footer>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
